import { useQuery } from 'react-query';
import { productService } from 'services';
import { ServerStateKeysEnum } from '../constants';

interface useFetchFavouriteProductIdsOptions {
  enabled?: boolean;
}

export const useFetchFavouriteProductIds = (
  options?: useFetchFavouriteProductIdsOptions
) => {
  return useQuery(
    `${ServerStateKeysEnum.favouriteProductIds}`,
    () => {
      return productService.getFavouriteProductIds();
    },
    { staleTime: Infinity, enabled: options?.enabled ?? true }
  );
};
